import React from "react";
import styled from "styled-components";
import aiIconBlue from "~/assets/svg/ai_icon_blue.svg";
import aiIconBlack from "~/assets/svg/ai_icon_black.svg";

interface PhotoEnhancerIconProps {
  isActive?: boolean;
  size?: "sm" | "md" | "lg";
  className?: string;
}

const IconWrapper = styled.div<{ size: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  img {
    width: ${(props) => {
      switch (props.size) {
        case "sm":
          return "18px";
        case "md":
          return "22px";
        case "lg":
          return "26px";
        default:
          return "18px";
      }
    }};
    height: ${(props) => {
      switch (props.size) {
        case "sm":
          return "18px";
        case "md":
          return "22px";
        case "lg":
          return "26px";
        default:
          return "18px";
      }
    }};
  }
`;

const PhotoEnhancerIcon: React.FC<PhotoEnhancerIconProps> = ({
  isActive = false,
  size = "sm",
  className,
}) => {
  const iconSrc = isActive ? aiIconBlue : aiIconBlack;

  return (
    <IconWrapper size={size} className={className}>
      <img src={iconSrc} alt="Photo Enhancer Icon" />
    </IconWrapper>
  );
};

export default PhotoEnhancerIcon;
